// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-R":"R_load-shedding-R__qCBth"};